var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[(_vm.show)?_c('v-btn',{staticClass:"to-top-btn",attrs:{"fixed":"","bottom":"","right":"","fab":"","small":"","depressed":"","color":"primary"},on:{"click":function($event){return _vm.$vuetify.goTo(_vm.target, _vm.options)}}},[_c('v-icon',{attrs:{"size":"26","color":"white"}},[_vm._v("mdi-chevron-up")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }